(function (){
    'use strict';

    angular
        .module('countryDirective', []);
})();